const requireComponent = require.context('.', true, /\.json$/);
let definitions = {};

requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)

    // Gets the name regardless of folder depth
    const componentName = fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')

    definitions[componentName] = componentConfig;
});

export default definitions;